import request from '@/utils/request'
/**
* @fileOverview 相关文档
*/

/**
* @description 文档列表
*/
export function getFiles(params) {
  return request({
    url: '/files',
    method: 'get',
    params
  })
}

/**
* @description 添加文档
* @param {string} data.name 文件名称
* @param {string} data.url 文件对象
*/
export function addFiles(data) {
  return request({
    url: '/files',
    method: 'post',
    data
  })
}

/**
* @description 删除文档
* @param {string} id 文档id
*/
export function deleteFiles(id) {
  return request({
    url: `/files/${id}`,
    method: 'delete'
  })
}

/**
* @description 导入获奖结果
* @param {string} data.name 文件名称
* @param {string} data.excel 文件对象
*/
export function importResult(data) {
  return request({
    url: '/searchs/importResult',
    method: 'post',
    data
  })
}

/**
* @description 导入复评费用
* @param {string} data.name 文件名称
* @param {string} data.excel 文件对象
*/
export function importNomination(data) {
  return request({
    url: '/searchs/importNomination',
    method: 'post',
    data
  })
}

/**
* @description 导出作品获奖服务
* @param {string} data.award_id //奖项
* @param {string} data.pi_code //参数编号
* @param {string} data.name_cn //作品名称中文
* @param {string} data.name_en //作品名称英文
* @param {string} data.type_cn //作品类型中文
* @param {string} data.type_en //作品类型英文
* @param {string} data.name //申请人姓名
* @param {string} data.email //电子邮件
* @param {string} data.register_status //注册状态
* @param {string} data.delivery_status  //递交状态
* @param {string} data.category_id //类别
* @param {string} data.pay_status //支付状态
*/
export function exportOrder(data) {
  return request({
    url: '/searchs/exportOrder',
    method: 'post',
    data
  })
}
